// extracted by mini-css-extract-plugin
export default {"title":"Products_title__NIP7g","description":"Products_description__2r6Qy","card":"Products_card__d-uta"};